import { ReportType } from '../types';
import Icon from '../../../components/AppIcon';

interface ReportTypeSelectorProps {
  reportTypes: ReportType[];
  selectedType: string;
  onTypeChange: (typeId: string) => void;
}

const ReportTypeSelector = ({ reportTypes, selectedType, onTypeChange }: ReportTypeSelectorProps) => {
  return (
    <div className="bg-card rounded-md border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Report Type</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {reportTypes.map((type) => (
          <button
            key={type.id}
            onClick={() => onTypeChange(type.id)}
            className={`
              p-4 rounded-sm border-2 transition-interactive hover-scale
              ${selectedType === type.id
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
              }
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`
                w-10 h-10 rounded-sm flex items-center justify-center flex-shrink-0
                ${selectedType === type.id ? 'bg-primary' : 'bg-muted'}
              `}>
                <Icon 
                  name={type.icon} 
                  size={20} 
                  color={selectedType === type.id ? 'var(--color-primary-foreground)' : 'var(--color-muted-foreground)'}
                />
              </div>
              <div className="flex-1 text-left">
                <h4 className={`text-sm font-medium mb-1 ${
                  selectedType === type.id ? 'text-primary' : 'text-foreground'
                }`}>
                  {type.label}
                </h4>
                <p className="text-xs text-muted-foreground">{type.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportTypeSelector;